<template>
  <li
    class="option-template-default"
    :class="{
      'single': singleSelect,
      'colored': displayColor,
      'focused': isFocused,
      'disabled': isDisabled
    }"
    @click="optionSelected"
  >
    <div
      class="color-swatch"
      v-if="displayColor"
      :style="{
        'background-color': !isDisabled ? colorValue : undefined
      }"
    />

    <label
      v-text="displayText"
      class="option-template-label"
      :title="displayText"
    />

    <checkbox-input
      class="checkbox-class"
      v-if="!singleSelect"
      :value="selected"
    />
  </li>
</template>

<script>
  import CheckboxInput from '../../checkbox/CheckboxInput'

  export default {
    name: 'OptionTemplateDefault',
    components: {
      'checkbox-input': CheckboxInput
    },
    data () {
      return {
      }
    },
    props: {
      optionData: {
        default: function () {
          return {}
        },
        type: Object
      },
      settings: {
        default: function () {
          return {
            displayKey: 'Name',
            showColor: false,
            tall: true,
            singleSelect: false
          }
        },
        type: Object
      }
    },
    methods: {
      optionSelected () {
        let self = this
        self.$emit('optionSelected', self.optionData)
      }
    },
    computed: {
      selected () {
        let self = this
        let result = self.optionData.selected
        return result
      },
      isDisabled () {
        let self = this
        return self.optionData.disabled === true
      },
      isFocused () {
        let self = this
        let result = self.optionData.isFocusedOption
        return result
      },
      displayKey () {
        let self = this
        let result = self.settings.displayKey
        return result
      },
      displayText () {
        let self = this
        let result = self.optionData[self.displayKey]
        return result
      },
      tall () {
        let self = this
        let result = self.settings.tall
        return result
      },
      displayColor () {
        let self = this
        let result = self.settings.displayColor
        return result
      },
      singleSelect () {
        let self = this
        let result = self.settings.singleSelect
        return result
      },
      colorValue () {
        let self = this
        let result = null

        if (self.optionData && self.settings.colorKey) {
          result = '#' + self.optionData[self.settings.colorKey]
        }

        return result
      },
      selectionHeight () {
        return this.tall ? 50 : 28
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../uikit';

  .option-template-default {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    * {
      vertical-align: middle;
    }

    .color-swatch {
      border-radius: 50%;
      display: inline-block;
      height: 18px;
      line-height: 18px;
      margin-left: 10px;
      width: 18px;
    }

    label {
      cursor: pointer;
      display: inline-block;
      width: calc(100% - 50px);
      padding: 0 10px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .checkbox-class {
      display: inline-block;
      line-height: 16px;
      pointer-events: none;
    }

    &.colored {
      label {
        width: calc(100% - 80px);

        @supports (-moz-appearance:none) {
          width: calc(100% - 82px);
        }

        @supports (-ms-ime-align:auto) {
          width: calc(100% - 85px);
        }
      }
    }

    &.single {
      label {
        width: 100%;
      }

      &.colored {
        label {
          width: calc(100% - 32px);

          @supports (-moz-appearance:none) {
            width: calc(100% - 32px);
          }

          @supports (-ms-ime-align:auto) {
            width: calc(100% - 35px);
          }
        }
      }
    }

    &.disabled {
      pointer-events: none;

      .color-swatch {
        background-color: $iconSvgColorDisabled;
      }

      .option-template-label {
        color: $lightGreyFont;
      }
    }

    &:hover {
      background: $lightGreyBackground;
    }

    &.focused {
      background: $mediumGreyBackground;
    }
  }

</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/kit-components/input-templates/selection/option-templates/OptionTemplateDefault.vue